import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { deletingZone } from 'utils/Zones'

const Delete = ({open, setOpen, selectedRow, reloading}) => {
    const { t } = useTranslation()
    const [loadingDeletingZone, setLoadingDeletingZone] = useState(false)

    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>
                    <Typography variant='body3'>{ t('settings.zones.titles.delete') }</Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography variant='body1'>
                        {t('settings.zones.alerts.delete.message')}
                    </Typography>

                    <ul>
                        { selectedRow.map((zone, index) =>
                            <li key={index}>
                                {zone.name}
                            </li>
                        )}
                    </ul>
                </DialogContent>

                <DialogActions sx={{pb: 2, pr: 3}}>
                    <LoadingButton
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            deletingZone(
                                setLoadingDeletingZone,
                                selectedRow,
                                () => { setOpen(false) },
                                reloading
                            )
                        }}
                        color='error'
                        loading={loadingDeletingZone}
                    >
                        {t('general.buttons.delete')}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Delete